module.exports = __webpack_public_path__ + "img/huotuixianrou.89a20e35.jpg";